import $ from 'jquery';
import BaseClass from '../../libs/base/BaseClass';
import RippleManagerClass from '../common/RippleManagerClass';
import ToggleBaseClass from '../common/ToggleBaseClass';
import Util from '../../libs/util/Util';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter.js';

/**
 * 最新の格安航空券料金
 */
export default class RecommendTicketClass extends BaseClass {
  constructor() {
    super();
    this.name = 'RecommendTicketClass';

    this.list = LtikeCommon.AIRPLANE.RECOMMEND_TICKET_LIST;

    this.tmpRipple = null;
  }

  onCreate() {
    this.target = $('.wrap_recommend_ticket .items');
  }

  onResize(_size) {
    if (this.tmpRipple) {
      this.tmpRipple.onResize(_size);
    }
  }

  onSetData() {
    const target = this.target;

    const price = Util.MASTER_AIRPLANE_PRICE_LIST;
    const airport = Util.MASTER_AIRPORT_DATA;
    // console.log(this.name, 'onSetData', airport);

    let html = '';

    // pc:4,6,6
    // sp:8,8

    const items = [];
    let count = 0;
    let key = 0;
    let monthInUse = [dayjs().month(), dayjs().month() + 1, dayjs().month() + 2];
    const now = dayjs();
    let endDay = now.add(3, 'month').set('date', 1);
    for (let k in this.list) {
      const fromCode = this.list[k].from;
      const toCode = this.list[k].to;
      let list = {};
      if (price[fromCode]) {
        list = price[fromCode][toCode];
      } else if (price[toCode]) {
        list = price[toCode][fromCode];
      }

      var data = null;
      var lowestPriceIn3Month = 10000000;
      for (let a in list) {
        if (monthInUse.indexOf(dayjs(a).month()) === -1) {
          continue;
        }
        // ３ヶ月後は対象外
        dayjs.extend(isSameOrAfter);
        if (dayjs(a).isSameOrAfter(endDay)) {
          continue;
        }
        if (parseInt(list[a].airtiket_price) < lowestPriceIn3Month) {
          lowestPriceIn3Month = parseInt(list[a].airtiket_price);
          data = null;
          data = list[a];
        }
      }
      if (data === null) { continue; }

      /* const dep = airport[data.dep_code];
        const arrive = airport[data.obj_code];
        //console.log(data.dep_code,data.obj_code);
        html += '<li><a href="" class="js-ripple"><div class="from_to"><dl>';
        html += '<dt>'+dep.disp_name+'</dt>';
        html += '<dd>'+dep.citynamej+'</dd></dl>';
        html += '<dl>';
        html += '<dt>'+arrive.disp_name+'</dt>';
        html += '<dd>'+arrive.citynamej+'</dd></dl></div>';
        html += '<div class="price">';
        html += Util.numberToPrice(data.airticket_price | 0) + ' 〜';
        html += '</div></a></li>';
        //console.log(data);*/
      if (Util.isBreakpoint) {
        if (count < 8) {
          key = 0;
        } else {
          key = 1;
        }
      } else {
        if (count < 4) {
          key = 0;
        } else if (count >= 4 && count < 10) {
          key = 1;
        } else {
          key = 2;
        }
      }

      if (!items[key]) { items[key] = []; }
      items[key].push(data);
      count++;
    }

    if (Util.isBreakpoint) {
      for (let k in items) {
        if (k | 0 === 1) { html += '<div class="toggle_target" data-toggle_id="recommend_ticket_items"><div class="toggle_target_inner">'; }
        html += `<ul>${this.getLiHtml(items[k], airport)}</ul>`;
        if (k | 0 === 1) { html += '</div></div>'; }
      }
      html += '<a href="" class="btn_more css_button simple js-ripple" data-toggle_target="recommend_ticket_items"><span class="css_button_inner">もっと見る</span></a>';
    } else {
      for (let k in items) {
        html += `<ul>${this.getLiHtml(items[k], airport)}</ul>`;
      }
    }

    target.html(html);


    this.tmpRipple = new RippleManagerClass(target);
    this.tmpRipple.onCreate();
    this.tmpRipple.onResize(Util.getWindowSize());

    this.tmpToggle = new ToggleBaseClass('recommend_ticket_items');
    this.tmpToggle.onCreate();
  }

  getLiHtml(_data, _airport) {
    let html = '';
    let airflg = '';
    /** @var {string} 最安値チケットページへの遷移先 */
    const href = document.location.protocol + '//' + window.location.host + '/flights/domestic/lowest-price';
    if ($('input[name="airflg"]').val() === '1') {
      airflg = '?airflg=1';
    }

    for (let a in _data) {
      const data = _data[a];
      const dep = _airport[data.dep_code];
      const arrive = _airport[data.obj_code];
      if (!dep || !arrive) {
        // 定義がないデータは表示処理をしない
        continue;
      }

      // 時間計算
      let now = new Date();
      let nextweek = this.formatDate(new Date(now.getFullYear(), now.getMonth(), now.getDate()+7));

      html += `<li><a href="${href}/${data.dep_code}-${data.obj_code}/" class="js-ripple">
        <div class="wrap">
          <div class="from_to">
            <dl>
              <dt>${dep.namej}</dt>
              <dd>${dep.citynamej}</dd>
            </dl>
            <dl>
              <dt>${arrive.namej}</dt>
              <dd>${arrive.citynamej}</dd>
            </dl>
          </div>
          <div class="price">${Util.numberToPrice(data.airtiket_price | 0)} 〜</div>
        </div>
      </a></li>`;
    }
    return html;

  }

  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('');
  }
}
